/**
 * Allowed `orderBy` field names for GET /ap/bills (format: field:asc|desc).
 * Keep in sync with BillService SQL + Prisma ordering.
 */
export const BILL_LIST_ORDER_BY_FIELDS = [
  'dueDate',
  'scheduledDate',
  'totalAmount',
  'billIssueDate',
  'vendor',
  'vendorBillNumber',
  'createdAt',
  'billStatus',
  'postedDate',
  'billCompetencyDate',
  'description',
  'source',
  'paymentMethod',
  'isRecurring',
  'taxRetention',
  'taxCredits',
  'retainedAmount',
  'contabil',
  'gerencial',
  'costCenter',
  'department',
  'categoria',
  'entity',
  'billType',
  'paymentStatus',
  'originBankAccount',
  'bankReturnMessage',
] as const;

/** Stable segment identity, also used by the bill table's column preferences. */
export type BillSegmentOrderField = `segment_${string}`;

export function isBillSegmentOrderField(value: string): value is BillSegmentOrderField {
  return /^segment_(?:group_)?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    value,
  );
}

export type BillOrderByField = (typeof BILL_LIST_ORDER_BY_FIELDS)[number] | BillSegmentOrderField;

export function isBillOrderByField(value: string): value is BillOrderByField {
  return (
    (BILL_LIST_ORDER_BY_FIELDS as readonly string[]).includes(value) ||
    isBillSegmentOrderField(value)
  );
}

/** Group keys keep old entity-specific sort fields backward compatible. */
export function billSegmentOrderIdentity(field: BillSegmentOrderField): {
  segmentId: string;
  matchEquivalent: boolean;
} {
  const matchEquivalent = field.startsWith('segment_group_');
  return {
    segmentId: field.slice(matchEquivalent ? 'segment_group_'.length : 'segment_'.length),
    matchEquivalent,
  };
}
